import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Title
);

const TasksChart = ({ activityLevel }) => {
    const [chartData, setChartData] = useState({});
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        if (Array.isArray(activityLevel) && activityLevel.length > 0) {
            // Filter to keep only the latest entry for each week_no
            const uniqueActivityData = activityLevel.reduce((acc, current) => {
                const existing = acc.find(item => item.week_no === current.week_no);
                if (!existing || existing.checkin_date < current.checkin_date) {
                    return acc.filter(item => item.week_no !== current.week_no).concat(current);
                }
                return acc;
            }, []);

            const sortedActivityData = uniqueActivityData.sort((a, b) => a.week_no - b.week_no);
            const labels = sortedActivityData.map(item => `Week ${item.week_no}`);
            const data = sortedActivityData.map(item => item.activity_level);

            setChartData({
                labels,
                datasets: [
                    {
                        data: data,
                        borderColor: '#FC6448',
                        backgroundColor: '#15B1D7',
                        pointBackgroundColor: '#FFF',
                        pointBorderColor: '#15B1D7',
                        pointRadius: 5,
                        borderWidth: 2,
                        spanGaps: true,
                    },
                ],
            });
            setIsDataLoaded(true);
        } else {
            setIsDataLoaded(false);
        }
    }, [activityLevel]);

    const options = {
        scales: {
            x: {
                // title: {
                //     display: true,
                //     text: 'Week No',
                // },
            },
            y: {
                // title: {
                //     display: true,
                //     text: 'Activity Level',
                // },
                min: 1,
                max: 10,
                ticks: {
                    stepSize: 1,
                    callback: (value) => value.toFixed(0),
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
        },
        maintainAspectRatio: false,
    };

    return (
        <section className="metrics-section">
            <h3 className="card-title">Activity Level</h3>
            <div style={{ height: '200px', width: '100%'}}>
                {isDataLoaded ? (
                    <Line data={chartData} options={options} style={{ width: '100%' }} />
                ) : (
                    <p>No data available</p>
                )}
            </div>
        </section>
    );
};

export default TasksChart;
